import ElasticService from "./elastic.service";

export const OPERATOR_ID_KEY = "operator";

function operatorId() {
  return parseInt(localStorage.getItem(OPERATOR_ID_KEY));
}

class LogsService {
  getCameraLogs(id, params = {}) {
    const cameraMust = [
      {
        term: {
          id,
        },
      },
    ];

    const cameraMustNot = [
      {
        term: {
          "editor_user.keyword": "m2m_reboot_corrupt",
        },
      },
    ];

    return ElasticService.get("camera", params, cameraMust, cameraMustNot);
  }

  getCameraMonitoring(id, params = {}) {
    const cameraMust = [
      {
        term: {
          id,
        },
      },
      {
        term: {
          "editor_user.keyword": "m2m_reboot_corrupt",
        },
      },
    ];

    return ElasticService.get("camera", params, cameraMust);
  }

  getEmployeesLogs(params = {}) {
    const employeesMust = [
      {
        term: {
          id_operator: operatorId(),
        },
      },
    ];

    return ElasticService.get("operator_employees", params, employeesMust);
  }

  getClientsLogs(params = {}) {
    const clientsMust = [
      {
        term: {
          id_operator: operatorId(),
        },
      },
    ];

    return ElasticService.get("operator_clients", params, clientsMust);
  }

  getServersLogs = (params = {}) => ElasticService.get("server", params);
}

export default new LogsService();
